<div class="container-fluid" style="margin-top: 11rem !important;">
  <div class="row ">
    <div class="col-xl-12 pl-3 pl-xl-0 order-xl-1 order-2">
      <div class="row">
        <div class="col-xl-7 col-md-7 pl-3 pl-xl-0 order-xl-1 order-md-1 order-2">
          <ng-container>
            <div class=" mb-0 border-0">
              <div class="row no-gutters">
                <div class="col-xl-12  pl-md-4 pl-xl-0">
                  <div class="user-details">
                    <h2 style="font-weight:bold">Farmer Information</h2>
                    <div class="mb-2">
                      <span class="card-title mr-2">
                        <span class="ph">
                          {{animalDetails?.farmer_name}}
                        </span>
                        <span class="ph"> (RegId: &nbsp;{{animalDetails?.id}})</span>&nbsp;
                      </span><br>
                      &nbsp;<span class="ph">Ph:</span>
                      <span >
                        &nbsp;{{animalDetails?.mobile_number}}</span>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <span class="ph">Address :</span><span> &nbsp;{{animalDetails?.address}}</span>
                    </div>


                  </div>
                  <div class="user-details mt-4">
                    <h2 style="font-weight:bold">Animal Information</h2>
                    <div class="mb-2">
                      <span class="card-title mr-2"></span>
                        <span class="ph">Animal Name :</span>   <span>&nbsp;{{animalDetails?.animal_type}}</span>&nbsp;&nbsp;
                        <span class="ph"> Breed : </span>          <span>&nbsp;{{animalDetails?.breed_type}}</span>&nbsp;&nbsp;
                        <span class="ph"> Gender :</span>          <span>&nbsp;{{animalDetails?.gender}}</span>&nbsp;&nbsp;<br> &nbsp;
                        <!-- <span class="ph">LUID:</span>              <span> {{animalDetails?.luid}}</span><br> -->
                      <!-- <span class="ph">Identification Details :</span><span> {{}}</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="col-xl-5 col-md-5  pt-xl-0 pt-3  order-xl-2 order-md-2 order-1 px-xl-0">
          <aside class="sticky-sidebar">
            <ng-container >
              <ul class="list-inline mb-0">
                <li class="list-inline-item">
                  <button type="button" class="btn btn-sm btn-primary font-weight-bold mb-2" data-toggle="modal"
                    data-target="#emergencyModal" (click)="emergencyComment=''">
                    <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4 17V15H5.6L7.575 8.425C7.70833 7.99167 7.954 7.64567 8.312 7.387C8.67067 7.129 9.06667 7 9.5 7H12.5C12.9333 7 13.3293 7.129 13.688 7.387C14.046 7.64567 14.2917 7.99167 14.425 8.425L16.4 15H18V17H4ZM7.7 15H14.3L12.5 9H9.5L7.7 15ZM10 5V0H12V5H10ZM15.95 7.475L14.525 6.05L18.075 2.525L19.475 3.925L15.95 7.475ZM17 12V10H22V12H17ZM6.05 7.475L2.525 3.925L3.925 2.525L7.475 6.05L6.05 7.475ZM0 12V10H5V12H0Z"
                        fill="white" />
                    </svg>
                    Emergency
                  </button>
                </li>
                <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold" (click)="openViewFileModal()">
                    <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21.257 10.962C21.731 11.582 21.731 12.419 21.257 13.038C19.764 14.987 16.182 19 12 19C7.81801 19 4.23601 14.987 2.74301 13.038C2.51239 12.7411 2.38721 12.3759 2.38721 12C2.38721 11.6241 2.51239 11.2589 2.74301 10.962C4.23601 9.013 7.81801 5 12 5C16.182 5 19.764 9.013 21.257 10.962V10.962Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
    
                    View Files
                  </button></li>
                <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold" (click)="farmerHistory()">
                    <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 8V13H17V11H14V8H12Z" fill="white" />
                      <path
                        d="M21.292 8.497C20.8409 7.42705 20.1861 6.45501 19.364 5.635C18.1196 4.39057 16.5377 3.5381 14.814 3.183C13.6176 2.93949 12.3844 2.93949 11.188 3.183C9.46267 3.53584 7.87947 4.389 6.636 5.636C5.81589 6.45689 5.16133 7.42786 4.708 8.496C4.23911 9.60461 3.99832 10.7963 4 12L4.001 12.025H2L5 16L8 12.025H6.001L6 12C5.99712 10.6054 6.41346 9.24207 7.195 8.087C7.69912 7.34169 8.34095 6.69952 9.086 6.195C9.84394 5.68441 10.6941 5.3264 11.589 5.141C13.4075 4.7671 15.3001 5.13063 16.8507 6.15167C18.4013 7.17271 19.483 8.7677 19.858 10.586C20.0466 11.5179 20.0466 12.4781 19.858 13.41C19.675 14.3056 19.3168 15.1563 18.804 15.913C18.554 16.284 18.267 16.633 17.95 16.949C17.3112 17.587 16.5558 18.0966 15.725 18.45C15.3018 18.6289 14.862 18.7655 14.412 18.858C13.4804 19.0465 12.5206 19.0465 11.589 18.858C10.6943 18.6746 9.84447 18.3168 9.088 17.805C8.71595 17.5536 8.36871 17.2673 8.051 16.95L6.637 18.364C7.47212 19.2003 8.46403 19.8636 9.5559 20.3159C10.6478 20.7682 11.8181 21.0007 13 21C14.2031 20.9995 15.3939 20.7592 16.503 20.293C18.1106 19.6128 19.486 18.4803 20.462 17.033C21.4665 15.5469 22.0022 13.7937 22 12C22.0025 10.7966 21.7617 9.60502 21.292 8.497Z"
                        fill="white" />
                    </svg>
    
                    History
                  </button></li>
                <!-- <li class="list-inline-item"  *ngIf="isEnableCovid19"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    (click)="openModal()">
                    <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.75 3C5.02065 3 4.32118 3.28973 3.80546 3.80546C3.28973 4.32118 3 5.02065 3 5.75V18.25C3 18.9793 3.28973 19.6788 3.80546 20.1945C4.32118 20.7103 5.02065 21 5.75 21H18.25C18.9793 21 19.6788 20.7103 20.1945 20.1945C20.7103 19.6788 21 18.9793 21 18.25V5.75C21 5.02065 20.7103 4.32118 20.1945 3.80546C19.6788 3.28973 18.9793 3 18.25 3H5.75ZM4.5 5.75C4.5 5.06 5.06 4.5 5.75 4.5H18.25C18.94 4.5 19.5 5.06 19.5 5.75V18.25C19.5 18.94 18.94 19.5 18.25 19.5H5.75C5.06 19.5 4.5 18.94 4.5 18.25V5.75ZM7.5 10.75C7.5 10.5511 7.57902 10.3603 7.71967 10.2197C7.86032 10.079 8.05109 10 8.25 10C8.44891 10 8.63968 10.079 8.78033 10.2197C8.92098 10.3603 9 10.5511 9 10.75C9 10.9489 8.92098 11.1397 8.78033 11.2803C8.63968 11.421 8.44891 11.5 8.25 11.5C8.05109 11.5 7.86032 11.421 7.71967 11.2803C7.57902 11.1397 7.5 10.9489 7.5 10.75ZM8.25 8.5C7.65326 8.5 7.08097 8.73705 6.65901 9.15901C6.23705 9.58097 6 10.1533 6 10.75C6 11.3467 6.23705 11.919 6.65901 12.341C7.08097 12.7629 7.65326 13 8.25 13C8.84674 13 9.41903 12.7629 9.84099 12.341C10.2629 11.919 10.5 11.3467 10.5 10.75C10.5 10.1533 10.2629 9.58097 9.84099 9.15901C9.41903 8.73705 8.84674 8.5 8.25 8.5ZM8.25 15.5C8.05109 15.5 7.86032 15.579 7.71967 15.7197C7.57902 15.8603 7.5 16.0511 7.5 16.25C7.5 16.4489 7.57902 16.6397 7.71967 16.7803C7.86032 16.921 8.05109 17 8.25 17C8.44891 17 8.63968 16.921 8.78033 16.7803C8.92098 16.6397 9 16.4489 9 16.25C9 16.0511 8.92098 15.8603 8.78033 15.7197C8.63968 15.579 8.44891 15.5 8.25 15.5ZM6 16.25C6 15.9545 6.0582 15.6619 6.17127 15.389C6.28434 15.116 6.45008 14.8679 6.65901 14.659C6.86794 14.4501 7.11598 14.2843 7.38896 14.1713C7.66194 14.0582 7.95453 14 8.25 14C8.54547 14 8.83806 14.0582 9.11104 14.1713C9.38402 14.2843 9.63206 14.4501 9.84099 14.659C10.0499 14.8679 10.2157 15.116 10.3287 15.389C10.4418 15.6619 10.5 15.9545 10.5 16.25C10.5 16.8467 10.2629 17.419 9.84099 17.841C9.41903 18.2629 8.84674 18.5 8.25 18.5C7.65326 18.5 7.08097 18.2629 6.65901 17.841C6.23705 17.419 6 16.8467 6 16.25ZM12.25 10C12.0511 10 11.8603 10.079 11.7197 10.2197C11.579 10.3603 11.5 10.5511 11.5 10.75C11.5 10.9489 11.579 11.1397 11.7197 11.2803C11.8603 11.421 12.0511 11.5 12.25 11.5H17.25C17.4489 11.5 17.6397 11.421 17.7803 11.2803C17.921 11.1397 18 10.9489 18 10.75C18 10.5511 17.921 10.3603 17.7803 10.2197C17.6397 10.079 17.4489 10 17.25 10H12.25ZM11.5 16.25C11.5 16.0511 11.579 15.8603 11.7197 15.7197C11.8603 15.579 12.0511 15.5 12.25 15.5H17.25C17.4489 15.5 17.6397 15.579 17.7803 15.7197C17.921 15.8603 18 16.0511 18 16.25C18 16.4489 17.921 16.6397 17.7803 16.7803C17.6397 16.921 17.4489 17 17.25 17H12.25C12.0511 17 11.8603 16.921 11.7197 16.7803C11.579 16.6397 11.5 16.4489 11.5 16.25ZM6.75 6C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5H17.25C17.4489 7.5 17.6397 7.42098 17.7803 7.28033C17.921 7.13968 18 6.94891 18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H6.75Z"
                        fill="white" />
                    </svg>
    
                    Covid Form
                  </button></li> -->
                  <!-- <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    (click)="openViewFileModal('Insurance')" *ngIf="enableInsuranceDetailsInPoc">
                    <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21.257 10.962C21.731 11.582 21.731 12.419 21.257 13.038C19.764 14.987 16.182 19 12 19C7.81801 19 4.23601 14.987 2.74301 13.038C2.51239 12.7411 2.38721 12.3759 2.38721 12C2.38721 11.6241 2.51239 11.2589 2.74301 10.962C4.23601 9.013 7.81801 5 12 5C16.182 5 19.764 9.013 21.257 10.962V10.962Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
    
                    Insurance Files
                  </button></li> -->
    
                <!-- <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    (click)="viewID()" *ngIf="isukt">
                    <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.75 3C5.02065 3 4.32118 3.28973 3.80546 3.80546C3.28973 4.32118 3 5.02065 3 5.75V18.25C3 18.9793 3.28973 19.6788 3.80546 20.1945C4.32118 20.7103 5.02065 21 5.75 21H18.25C18.9793 21 19.6788 20.7103 20.1945 20.1945C20.7103 19.6788 21 18.9793 21 18.25V5.75C21 5.02065 20.7103 4.32118 20.1945 3.80546C19.6788 3.28973 18.9793 3 18.25 3H5.75ZM4.5 5.75C4.5 5.06 5.06 4.5 5.75 4.5H18.25C18.94 4.5 19.5 5.06 19.5 5.75V18.25C19.5 18.94 18.94 19.5 18.25 19.5H5.75C5.06 19.5 4.5 18.94 4.5 18.25V5.75ZM7.5 10.75C7.5 10.5511 7.57902 10.3603 7.71967 10.2197C7.86032 10.079 8.05109 10 8.25 10C8.44891 10 8.63968 10.079 8.78033 10.2197C8.92098 10.3603 9 10.5511 9 10.75C9 10.9489 8.92098 11.1397 8.78033 11.2803C8.63968 11.421 8.44891 11.5 8.25 11.5C8.05109 11.5 7.86032 11.421 7.71967 11.2803C7.57902 11.1397 7.5 10.9489 7.5 10.75ZM8.25 8.5C7.65326 8.5 7.08097 8.73705 6.65901 9.15901C6.23705 9.58097 6 10.1533 6 10.75C6 11.3467 6.23705 11.919 6.65901 12.341C7.08097 12.7629 7.65326 13 8.25 13C8.84674 13 9.41903 12.7629 9.84099 12.341C10.2629 11.919 10.5 11.3467 10.5 10.75C10.5 10.1533 10.2629 9.58097 9.84099 9.15901C9.41903 8.73705 8.84674 8.5 8.25 8.5ZM8.25 15.5C8.05109 15.5 7.86032 15.579 7.71967 15.7197C7.57902 15.8603 7.5 16.0511 7.5 16.25C7.5 16.4489 7.57902 16.6397 7.71967 16.7803C7.86032 16.921 8.05109 17 8.25 17C8.44891 17 8.63968 16.921 8.78033 16.7803C8.92098 16.6397 9 16.4489 9 16.25C9 16.0511 8.92098 15.8603 8.78033 15.7197C8.63968 15.579 8.44891 15.5 8.25 15.5ZM6 16.25C6 15.9545 6.0582 15.6619 6.17127 15.389C6.28434 15.116 6.45008 14.8679 6.65901 14.659C6.86794 14.4501 7.11598 14.2843 7.38896 14.1713C7.66194 14.0582 7.95453 14 8.25 14C8.54547 14 8.83806 14.0582 9.11104 14.1713C9.38402 14.2843 9.63206 14.4501 9.84099 14.659C10.0499 14.8679 10.2157 15.116 10.3287 15.389C10.4418 15.6619 10.5 15.9545 10.5 16.25C10.5 16.8467 10.2629 17.419 9.84099 17.841C9.41903 18.2629 8.84674 18.5 8.25 18.5C7.65326 18.5 7.08097 18.2629 6.65901 17.841C6.23705 17.419 6 16.8467 6 16.25ZM12.25 10C12.0511 10 11.8603 10.079 11.7197 10.2197C11.579 10.3603 11.5 10.5511 11.5 10.75C11.5 10.9489 11.579 11.1397 11.7197 11.2803C11.8603 11.421 12.0511 11.5 12.25 11.5H17.25C17.4489 11.5 17.6397 11.421 17.7803 11.2803C17.921 11.1397 18 10.9489 18 10.75C18 10.5511 17.921 10.3603 17.7803 10.2197C17.6397 10.079 17.4489 10 17.25 10H12.25ZM11.5 16.25C11.5 16.0511 11.579 15.8603 11.7197 15.7197C11.8603 15.579 12.0511 15.5 12.25 15.5H17.25C17.4489 15.5 17.6397 15.579 17.7803 15.7197C17.921 15.8603 18 16.0511 18 16.25C18 16.4489 17.921 16.6397 17.7803 16.7803C17.6397 16.921 17.4489 17 17.25 17H12.25C12.0511 17 11.8603 16.921 11.7197 16.7803C11.579 16.6397 11.5 16.4489 11.5 16.25ZM6.75 6C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5H17.25C17.4489 7.5 17.6397 7.42098 17.7803 7.28033C17.921 7.13968 18 6.94891 18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H6.75Z"
                        fill="white" />
                    </svg>
    
                    ID Proof
                  </button></li> -->
                  <!-- <li class="list-inline-item"> <button type="button"  class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    (click)="audioConsent()"  *ngIf="isukt && !isOffLinePOC() && ( audio_file_path || audio_file_path3 || audio_file_path2)">
                    <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.75 3C5.02065 3 4.32118 3.28973 3.80546 3.80546C3.28973 4.32118 3 5.02065 3 5.75V18.25C3 18.9793 3.28973 19.6788 3.80546 20.1945C4.32118 20.7103 5.02065 21 5.75 21H18.25C18.9793 21 19.6788 20.7103 20.1945 20.1945C20.7103 19.6788 21 18.9793 21 18.25V5.75C21 5.02065 20.7103 4.32118 20.1945 3.80546C19.6788 3.28973 18.9793 3 18.25 3H5.75ZM4.5 5.75C4.5 5.06 5.06 4.5 5.75 4.5H18.25C18.94 4.5 19.5 5.06 19.5 5.75V18.25C19.5 18.94 18.94 19.5 18.25 19.5H5.75C5.06 19.5 4.5 18.94 4.5 18.25V5.75ZM7.5 10.75C7.5 10.5511 7.57902 10.3603 7.71967 10.2197C7.86032 10.079 8.05109 10 8.25 10C8.44891 10 8.63968 10.079 8.78033 10.2197C8.92098 10.3603 9 10.5511 9 10.75C9 10.9489 8.92098 11.1397 8.78033 11.2803C8.63968 11.421 8.44891 11.5 8.25 11.5C8.05109 11.5 7.86032 11.421 7.71967 11.2803C7.57902 11.1397 7.5 10.9489 7.5 10.75ZM8.25 8.5C7.65326 8.5 7.08097 8.73705 6.65901 9.15901C6.23705 9.58097 6 10.1533 6 10.75C6 11.3467 6.23705 11.919 6.65901 12.341C7.08097 12.7629 7.65326 13 8.25 13C8.84674 13 9.41903 12.7629 9.84099 12.341C10.2629 11.919 10.5 11.3467 10.5 10.75C10.5 10.1533 10.2629 9.58097 9.84099 9.15901C9.41903 8.73705 8.84674 8.5 8.25 8.5ZM8.25 15.5C8.05109 15.5 7.86032 15.579 7.71967 15.7197C7.57902 15.8603 7.5 16.0511 7.5 16.25C7.5 16.4489 7.57902 16.6397 7.71967 16.7803C7.86032 16.921 8.05109 17 8.25 17C8.44891 17 8.63968 16.921 8.78033 16.7803C8.92098 16.6397 9 16.4489 9 16.25C9 16.0511 8.92098 15.8603 8.78033 15.7197C8.63968 15.579 8.44891 15.5 8.25 15.5ZM6 16.25C6 15.9545 6.0582 15.6619 6.17127 15.389C6.28434 15.116 6.45008 14.8679 6.65901 14.659C6.86794 14.4501 7.11598 14.2843 7.38896 14.1713C7.66194 14.0582 7.95453 14 8.25 14C8.54547 14 8.83806 14.0582 9.11104 14.1713C9.38402 14.2843 9.63206 14.4501 9.84099 14.659C10.0499 14.8679 10.2157 15.116 10.3287 15.389C10.4418 15.6619 10.5 15.9545 10.5 16.25C10.5 16.8467 10.2629 17.419 9.84099 17.841C9.41903 18.2629 8.84674 18.5 8.25 18.5C7.65326 18.5 7.08097 18.2629 6.65901 17.841C6.23705 17.419 6 16.8467 6 16.25ZM12.25 10C12.0511 10 11.8603 10.079 11.7197 10.2197C11.579 10.3603 11.5 10.5511 11.5 10.75C11.5 10.9489 11.579 11.1397 11.7197 11.2803C11.8603 11.421 12.0511 11.5 12.25 11.5H17.25C17.4489 11.5 17.6397 11.421 17.7803 11.2803C17.921 11.1397 18 10.9489 18 10.75C18 10.5511 17.921 10.3603 17.7803 10.2197C17.6397 10.079 17.4489 10 17.25 10H12.25ZM11.5 16.25C11.5 16.0511 11.579 15.8603 11.7197 15.7197C11.8603 15.579 12.0511 15.5 12.25 15.5H17.25C17.4489 15.5 17.6397 15.579 17.7803 15.7197C17.921 15.8603 18 16.0511 18 16.25C18 16.4489 17.921 16.6397 17.7803 16.7803C17.6397 16.921 17.4489 17 17.25 17H12.25C12.0511 17 11.8603 16.921 11.7197 16.7803C11.579 16.6397 11.5 16.4489 11.5 16.25ZM6.75 6C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5H17.25C17.4489 7.5 17.6397 7.42098 17.7803 7.28033C17.921 7.13968 18 6.94891 18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H6.75Z"
                        fill="white" />
                    </svg>
    
                    Audio Consent
                  </button></li>        -->
                <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-emg mb-2 font-weight-bold"
                    (click)="gotoConsultation()">
                  <i class="fa fa-times"></i>&nbsp;
    
                    Cancel POC
                  </button></li>
              </ul>
            </ng-container>
          </aside>
    
        </div>
      </div>
    </div>
   
  </div>

</div>

<div class="container-fluid">
  <h4 class="text-center mb-3" style="font-weight: 700; color: darkblue;">Plan Of Care</h4>
  <form [formGroup]="pocForm1">
  <div class="row"> 
    <div class="col-xl-6 mb-4">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <h5 class="card-header">Clinical Observations</h5>
        <div class="card-body" formGroupName="clinical_observation">
          <div class="row">
            <div class="col-xl-3 col-md-3">
              <div class="form-group">
                <label for="inputEmail4">Temperature</label>
                <div class="input_wrapper">
                  <input type="text" formControlName="temparature" id="temparature"
                    (change)="onTempChng($event.target.value)" maxlength="5"
                    onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46'
                    class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase" (keyup)="onTempChng($event.target.value)" />
                  <div class="unit">&deg; F</div>
                 
                </div>
              </div>
            </div>
  
            <div class="col-xl-3 col-md-3">
              <div class="form-group">
                <label for="inputEmail4">MM</label>
                <div class="input_wrapper">
                  <input type="text" autocomplete="off" formControlName="mucus_membrane"
                    id="mucus_membrane"
                    (keypress)="keyPressAlphaNumeric($event)" maxlength="3"
                    class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase">
                </div>
              </div>
            </div>
  
            <div class="col-xl-3 col-md-3">
              <div class="form-group">
                <label for="inputEmail4">CRT</label>
                <div class="input_wrapper">
                  <input type="text" autocomplete="off" formControlName="capillary_refill_time" id="capillary_refill_time"
                    (keyup)="keyUp('capillary_refill_time')"
                    onkeypress='return (event.charCode >= 48 && event.charCode <= 57)' maxlength="3"
                    
                    class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase">
                  
                </div>
              </div>
            </div>
  
        
            <div class="col-xl-3 col-md-3">
              <div class="form-group">
                <label for="inputEmail4">Respiration Rate</label>
                <div class="input_wrapper">
                  <input type="text" autocomplete="off" formControlName="respiratory_rate" id="respiratory_rate"
                    (keyup)="keyUp('respiratory_rate')"
                    onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                   
                    class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase">
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-3">
              <div class="form-group">
                <label for="inputEmail4">Rumen Motility</label>
                <div class="input_wrapper">
                  <input type="text" autocomplete="off" formControlName="rumen_movements" id="rumen_movements"
                    (keyup)="keyUp('rumen_movements')"
                    onkeypress='return (event.charCode >= 48 && event.charCode <= 57)' maxlength="3"
                    max="200" 
                    class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase">
                  
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-3">
              <div class="form-group">
                <label for="inputEmail4">STT</label>
                <div class="input_wrapper">
                  <input type="text" autocomplete="off" formControlName="stt" id="stt"
                    onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                    class="form-control form-control-sm  text-uppercase"
                   >
                 
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-3">
              <div class="form-group">
                <label for="inputEmail4">BCS</label>
                <div class="input_wrapper">
                   
                      <select formControlName="bcs" id="bcs" class="form-control form-control-sm" >
                        <option value="">Select</option>
                        <option *ngFor="let item of bcsList" [value]="item.id">
                          {{item.bcs}}</option>
                      </select>
                    
                 
                </div>
              </div>
            </div>
         
  
          </div>
          
        </div>
      </div>
    </div>

    <div class="col-xl-6 mb-4">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <h5 class="card-header">Symptoms</h5>
        <div class="card-body" formGroupName="symptoms">
          <div class="row">
            <div class="col-xl-12 mb-4">
              <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings"
              [data]="symptomsList" [(ngModel)]="selectedItemsList" [ngModelOptions]="{standalone: true}"
              (onSelectAll)="onSelectAllMVU($event)" 
              (onSelect)="onItemSelectMVU($event)" [ngModelOptions]="{standalone: true}"
              (onDeSelectAll)="onDeSelectAllMVU($event)"
              (onDeSelect)="onItemDeSelectMVU($event)">
          </ng-multiselect-dropdown>
            </div>
           
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-6 mb-4">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <h5 class="card-header">Anamnesis</h5>
        <div class="card-body" formGroupName="anamneasis">
          <div class="row">
            <div class="col-xl-4 col-md-4">
                <label class="control-label"> Deworming Status </label>
                <select formControlName="deworming_status" id="deworming_status" class="form-control form-control-sm" (change)="dewText($event.target.value)">
                  <option value="">Select</option>
                  <option *ngFor="let item of dewormingList" [value]="item.id">
                    {{item.deworming_status}}</option>
                </select>
                <input type="text" *ngIf="enableDeworming" class="mt-2" autocomplete="off" formControlName="deworming_status_other"
                   class="form-control form-control-sm" >
            </div>
            <div class="col-xl-4 col-md-4" >
                <label class="control-label"> Vaccination Status </label>
                <select formControlName="vaccination_status" id="vaccination_status" class="form-control form-control-sm" (change)="vacText($event.target.value)">
                  <option value="">Select</option>
                  <option *ngFor="let item of vaccinationList" [value]="item.id">
                    {{item.vaccination_status}}</option>
                </select>
                <input type="text" *ngIf="enableVac" class="mt-2" autocomplete="off" formControlName="vaccination_status_other"
                   class="form-control form-control-sm" >
            </div>
            <div class="col-xl-4 col-md-4">
                <label class="control-label"> Type of feeding </label>
                <input type="text" autocomplete="off" formControlName="type_of_feeding"
                   class="form-control form-control-sm" >
            </div>
            <div class="col-xl-4 col-md-4">
                <label class="control-label"> Change in food </label>
                <input type="text" autocomplete="off" formControlName="change_in_food" 
                   class="form-control form-control-sm" >
            </div>
            <div class="col-xl-4 col-md-4">
                <label class="control-label"> Change in environment </label>
                <input type="text" autocomplete="off" formControlName="change_in_environment"
                   class="form-control form-control-sm" >
            </div>
            <div class="col-xl-4 col-md-4">
                <label class="control-label"> Previous Illness </label>
                <input type="text" autocomplete="off" formControlName="previous_illness" 
                   class="form-control form-control-sm" >
            </div>
            <div class="col-xl-4 col-md-4">
                <label class="control-label"> Previous Surgery </label>
                <input type="text" autocomplete="off" formControlName="previous_surgery"
                   class="form-control form-control-sm" >
            </div>
            <div class="col-xl-4 col-md-4">
                <label class="control-label"> Previous Medication </label>
                <input type="text" autocomplete="off" formControlName="previous_treated_with"
                   class="form-control form-control-sm" >
            </div>
           </div>
        </div>
      </div>
    </div>

    <div class="col-xl-6 mb-4">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <h5 class="card-header">Tentative Diagnosis</h5>
        <div class="card-body" formGroupName="diagnosis">
          <div class="row">
            <div class="col-xl-12">
              <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdowndiagnosis"
              [data]="diagnosisList" [(ngModel)]="selectedDiagnosisList" [ngModelOptions]="{standalone: true}"
              (onSelectAll)="onSelectAllDiagnosis($event)" 
              (onSelect)="onItemSelectDiagnosis($event)" [ngModelOptions]="{standalone: true}"
              (onDeSelectAll)="onDeSelectAllDiagnosis($event)"
              (onDeSelect)="onItemDeSelectDiagnosis($event)">
          </ng-multiselect-dropdown>
            </div>
        </div>

        <div class="row mt-3 mb-4">
          <div class="col-xl-12">
            <label>Prognosis</label>
            <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownPrognosis"
            [data]="prognosisList" [(ngModel)]="selectedPrognosisList" [ngModelOptions]="{standalone: true}"
            (onSelectAll)="onSelectAllPrognosis($event)" 
            (onSelect)="onItemSelectPrognosis($event)" [ngModelOptions]="{standalone: true}"
            (onDeSelectAll)="onDeSelectAllPrognosis($event)"
            (onDeSelect)="onItemDeSelectPrognosis($event)">
        </ng-multiselect-dropdown>
          </div>
      </div>
      </div>
    </div>
</div>
    <div class="col-xl-6 mb-4">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <h5 class="card-header">Treatment Procedure</h5>
        <div class="card-body"  formGroupName="withdrawal_period">
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <div>
                    <textarea rows="3" formControlName="treatment_procedure" maxlength="3000"
                    class="form-control  text-uppercase">
              </textarea>
                
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="col-xl-6 mb-4">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <h5 class="card-header">Advice</h5>
        <div class="card-body" >
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <div>
                    <textarea rows="3" formControlName="comments" maxlength="3000"
                    class="form-control  text-uppercase">
              </textarea>
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-6 mb-4">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <h5 class="card-header">Medications</h5>
        <div class="card-body">
          <div class="form-group">
            <label for="inputEmail4">Drug Type
              <!-- <a role="button" style="cursor: pointer;" (click)="LoadMO('DN')" *ngIf="moreDN"
                class="ml-5"><b>{{txtMoreDN}}</b></a> -->
            </label>
            <button type="button" class="btn btn-primary btn-sm float-right mb-1" (click)="addRow()">Add
              Direction</button>
            <div>
              <ng-multiselect-dropdown [settings]="drugSettingsDrug" id="" [placeholder]="'Select'"
                 (onSelect)="onDrgSlct($event, 'dt')"
                (onDeSelect)="onDrgDeSlct('dt')" [data]="drugtypesList" [(ngModel)]="dT"
                [ngModelOptions]="{standalone: true}">
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div>
            <div class="form-group">
              <label for="inputPassword4">Drug Name</label>
              <div>

                <ng-multiselect-dropdown [settings]="drugNameSettings" [placeholder]="'Select'"
                  (onSelect)="onDrgSlct($event, 'dn')" 
                  [data]="drug_list" (onDeSelect)="onDrgDeSlct('dn')" [(ngModel)]="dN"
                  [ngModelOptions]="{standalone: true}" >
                </ng-multiselect-dropdown>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div class="col-xl-6 mb-4">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <h5 class="card-header">Investigations</h5>
        <div class="card-body" >
          <div formGroupName="investigation.investigation">
            <div class="">
              <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownInv"
              [data]="InvList" [(ngModel)]="selectedInvList" [ngModelOptions]="{standalone: true}"
              (onSelectAll)="onSelectAllInve($event)" 
              (onSelect)="onItemSelectInve($event)" [ngModelOptions]="{standalone: true}"
              (onDeSelectAll)="onDeSelectAllInve($event)"
              (onDeSelect)="onItemDeSelectInve($event)">
          </ng-multiselect-dropdown>
              
            </div>
            <div class="form-group">
              <label for="inputPassword4">Other Investigations</label>
              <div>
                <textarea rows="3" class="form-control  text-uppercase" 
                formControlName="otherInvestigation">
          </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-12 mb-4" *ngIf="pocForm1.get('prescribed_medications')['controls'].length> 0 ">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <div class="card-body">
          <div class="col-xl-12 mb-4">
            <div class="row">
              <div class="table-responsive">
                <table class="table table-striped table-bordered table-sm" style="width: 100%;">
                  <thead class="card-header">
                    <tr>
                      <th style="width:7%;" class="singleLine">S No </th>
                      <th>Drug Type</th>
                      <th>Drug Name</th>
                      <th>Dose</th>
                      <th>Root For Administration</th>
                      <th>Period</th>
                      <th>Count</th>
                      <th>Duration</th>
                      <th>Remarks</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody formArrayName="prescribed_medications">
                    <tr *ngFor="let item of pocForm1.get('prescribed_medications')['controls']; let i = index" [formGroupName]="i">
                      <td>{{ i + 1 }}</td>
                      <td>
                        <div style="width:13rem !important;">
                          <p class="mb-0" style="white-space: pre-wrap !important;"> <span
                              class="text-danger" *ngIf="item.get('type').value==''">*</span>
                            {{item.get('type').value}}
                           
                          </p>
                        </div>
                      </td>
                      <td>
                        <div style="width:13rem !important;">
                          <p class="mb-0" style="white-space: pre-wrap !important;"> <span
                              class="text-danger" *ngIf="item.get('name').value==''">*</span>
                            {{item.get('name').value}}
                           
                          </p>
                        </div>
                      </td>
                      <td><input type="text" formControlName="dosage" class="form-control form-control-sm"></td>
                      <td>
                        <select formControlName="administration_id" class="form-control form-control-sm" style="width: 7rem !important;"
                        (change)="onSelectedAdmin($event.target.value)">
                          <option value="">Select</option>
                          <option *ngFor="let item of administrationList" [value]="item.id">
                            {{item.root_of_administration}}</option>
                          
                        </select>
                      </td>
                      <td>
                        <select formControlName="period" class="form-control form-control-sm" style="width: 7rem !important;">
                          <option value="">Select</option>
                          <option value="Days">Days</option>
                          <option value="Weeks">Weeks</option>
                          <option value="Months">Months</option>
                          <option value="Years">Years</option>
                        </select><br>
                       
                      </td>
                      <td> <input type="text"  formControlName="count" class="form-control form-control-sm"></td>
                      <!-- <td  *ngIf="!(item.get('type').value=='Bolus')"></td> -->
                      <td>
                        <label><input type="checkbox" formControlName="mrng"> M</label>&nbsp;
                        <label><input type="checkbox" formControlName="aftr"> A</label><br>
                        <label><input type="checkbox" formControlName="evng"> E</label>&nbsp;&nbsp;
                        <label><input type="checkbox" formControlName="night"> N</label><br>
                        <label><input type="checkbox" formControlName="sos"> SOS</label>
                      </td>
                      <td><input type="text" formControlName="remarks" class="form-control form-control-sm"></td>
                      <td style="width:5%;">
                        <button (click)="deleteRow(i)" title="Delete" class="btn btn-sm btn-block">
                          <i class="fa fa-trash text-danger"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    
  

    <div class="col-xl-6 mb-4">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <h5 class="card-header">Withdrawal Period</h5>
        <div class="card-body" formGroupName="withdrawal_period">
          <div class="row">
            <div class="col-xl-4 col-md-4">
              <label class="control-label"> Milk days </label>
              <input type="text" autocomplete="off" formControlName="milk_days"
                 class="form-control form-control-sm" >
          </div>
          <div class="col-xl-4 col-md-4">
            <label class="control-label"> Meat Days </label>
            <input type="text" autocomplete="off" formControlName="meat_days"
               class="form-control form-control-sm" >
        </div>
           
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-6 mb-4">
      <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
        <!-- <h5 class="card-header">Withdrawal Period</h5> -->
        <div class="card-body">
          <div class="row">
            <div class="col-xl-6 col-md-6">
              <label for="inputEmail4">Follow up Date</label>
              <div>
                <input type="text" autocomplete="off" formControlName="followupDate" id="followupDate"
                  placeholder="Follow up Date" bsDatepicker [minDate]="minDate" #dp="bsDatepicker"
                  (focus)="dp.show()"
                  [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false,adaptivePosition: true,isAnimated: true }"
                  class="form-control ">
              </div>

            </div>
           
                    <div class="col-xl-6 col-md-6">
                      <div class="form-group form-check mr-auto" #myDiv>
                        <input type="checkbox" name="checkbox" [(ngModel)]="isPcChecked"
                          [ngModelOptions]="{standalone: true}">
                        <label  class="form-check-label ml-2" for="exampleCheck1" >Require Physical consultation
                        </label>
                      </div>
                    </div>
          
           
          </div>
        </div>
      </div>
    </div>



  </div>
  <div div class="mt-4 mb-4 mr-3 text-right">
    <button type="button" class="btn btn-Preview btn-emg font-weight-bold"
            (click)="gotoConsultation()">
            Cancel POC
          </button> &nbsp;
    <button type="button" class="btn btn-Preview btn-lg btn-sm" (click)="onSubMit()">Submit</button>

  </div>
</form>
</div>

<div class="modal" id="viewFiles" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">

          <div class="modal-header eMdlHdr">
              <h4 class="cardheading eMdlHdrClr mb-0 pt-1 pb-1">View Files</h4>
              <button type="button" class="close btn btn-light float-end eMdlClsBtn" data-dismiss="modal">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="row">
             <div class="table-responsive">
               <table datatable *ngIf="dtRenderV" class="table table-bordered table-sm table-striped small" >
                   <thead>
                       <tr class="sticky-top heading-bg">
                           <th>File Name</th>
                           <th>Date</th>
                           <th>Action</th>
                       </tr>
                   </thead>
                   <tbody>
                    
                    <tr *ngFor="let item of insuranceFilesList;let i=index">
                      <td>{{item.file_name}}</td>
                      <td>{{item?.created_on | date: 'dd-MM-yyyy'}}</td>
                      <td><span>
                         <a title="View" style="cursor: pointer;" (click)="openPath(item.view_path)"><i class="text-primary fa fa-eye"></i>&nbsp;</a></span></td>
                         <!-- <a title="Download" style="cursor: pointer;" (click)="openPath(item.download_path)"><i class="text-primary fa fa-eye"></i>&nbsp; &nbsp;</a> -->
                     </tr>
                   </tbody>
               </table>
           </div>
            </div>
             
           </div>
          <div class="modal-footer"> 
               <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">Close</button>
          </div>
      </div>
  </div>
  </div>

  <div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" style="z-index: 99999 !important;"
  id="emergencyModal" role="dialog" aria-labelledby="edit" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Do you want to Exit the Plan of Care ?</h5>
        <button type="button" id="buttonEmergency" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group ">
          <div class="col-md-12">
            <label>Comments</label>
            <textarea type="text" rows="5" class="form-control " [(ngModel)]="emergencyComment"> </textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm  btn-primary" data-dismiss="modal" (click)="emergencyExit()"
          data-dismiss="modal">Yes</button>
        <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="history" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">

          <div class="modal-header eMdlHdr">
              <h4 class="cardheading eMdlHdrClr mb-0 pt-1 pb-1">History</h4>
              <button type="button" class="close btn btn-light float-end eMdlClsBtn" data-dismiss="modal">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="row">
             <div class="table-responsive">
               <table datatable *ngIf="dtRenderH" class="table table-bordered table-sm table-striped small" >
                   <thead>
                       <tr class="sticky-top heading-bg">
                           <th>Date</th>
                           <th>Doctor Name</th>
                           <th>Case Number</th>
                           <th>Prescription</th>
                       </tr>
                   </thead>
                   <tbody>
                    
                    <tr *ngFor="let item of farmerHistoryList;let i=index">
                      <td>{{item?.created_on | date: 'dd-MM-yyyy'}}</td>
                      <td>{{item.doctor_name}}</td>
                      <td>{{item.case_number}}</td>
                         
                          <td><span>
                             <a title="View" style="cursor: pointer;" (click)="openPathHistory(item.prescritpion_view__path)"><i class="text-primary fa fa-eye"></i>&nbsp;</a></span></td>
                             <!-- <a title="Download" style="cursor: pointer;" (click)="openPath(item.download_path)"><i class="text-primary fa fa-eye"></i>&nbsp; &nbsp;</a> -->
                         </tr>
                   </tbody>
               </table>
           </div>
            </div>
             
           </div>
          <div class="modal-footer"> 
               <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">Close</button>
          </div>
      </div>
  </div>
  </div>

